<i class="ico ico-warning" *ngIf="warning"></i>
<a #tab class="tab {{ styleClass }}" (click)="tabClicked($event)" [class.is-active]="active">
	<ng-content></ng-content>
	<span class="tab-border"></span>
</a>
